import { useNavigate } from "react-router";
import { Divider } from "antd";
import AskVivoIcon from "@/assets/icons/ask_vivo2.svg?react";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useScopeParams } from "@/hooks/useScopeParams";

export default function InstructionsCard() {
  const navigate = useNavigate();
  const { buildUrl } = useScopeParams();

  return (
    <div
      className="flex flex-col gap-4 p-4 bg-white rounded-lg shadow-md text-[#2B4752]"
      data-testid="insights-instructions-card"
    >
      <h2 className="text-lg font-semibold">Create an insight</h2>
      <p className="text-base text-[#00000073]">
        Insights give you persistent, explainable, and refreshable visibility
        into your trial data. Create Insights from your AskVivo questions and
        see them collected and updated here at a cadence of your choice.
      </p>

      <Divider className="border-[#0000000f] m-2" />

      <div className="grid grid-cols-4 gap-x-3 gap-y-1 mb-4">
        {/* Row for titles */}
        <div className="text-center">
          <p className="text-lg font-medium">ASK</p>
        </div>
        <div className="text-center">
          <p className="text-lg font-medium">CREATE</p>
        </div>
        <div className="text-center">
          <p className="text-lg font-medium">SUBMIT</p>
        </div>
        <div className="text-center">
          <p className="text-lg font-medium">ALERT</p>
        </div>
        {/* Row for visualizations */}
        <div className="flex flex-col items-center p-3 gap-2">
          <div className="flex bg-[#064C68] gap-1 text-white w-[150px] h-[35px] rounded-sm items-center justify-center">
            <AskVivoIcon />
            <p className="text-sm font-medium">Ask Vivo</p>
          </div>
        </div>
        <div className="flex flex-col items-center p-3 gap-2">
          <div className="flex bg-[#D2EFF9] text-[#064C68] border border-[#064C68] gap-1 w-[150px] h-[35px] rounded-sm items-center justify-center">
            <p className="text-sm font-medium">Create Insight</p>
          </div>
        </div>
        <div className="flex flex-col items-center p-3 gap-2">
          <div className="flex bg-[#0C98D0] text-white gap-1 w-[150px] h-[35px] rounded-sm items-center justify-center">
            <p className="text-sm font-medium">Submit</p>
          </div>
        </div>
        <div className="flex flex-col items-center p-3 gap-2">
          <div className="flex bg-white text-[#2B4752] gap-1 w-[150px] h-[35px] border border-[#2B4752] rounded-sm items-center justify-center">
            <p className="text-sm font-medium">Add an alert</p>
          </div>
        </div>
        {/* Row for instructions */}
        <div className="text-center">
          <p className="text-base text-center">
            Ask Vivo a question you&apos;d like to ask on a repeat cadence.
          </p>
        </div>
        <div className="text-center">
          <p className="text-base text-center">
            Like the response? Create an Insight from it.
          </p>
        </div>
        <div className="text-center">
          <p className="text-base text-center">
            Select your categorization, cadence, and then submit.
          </p>{" "}
        </div>
        <div className="text-center">
          <p className="text-base text-center">
            Define a rule to trigger an alert.
          </p>
        </div>
      </div>
      <button
        data-testid="insights-try-it-yourself-button"
        className="bg-[#d2eff966] border border-[#0000001f] mt-4 rounded-sm shadow-xs p-[7px_13px_6px_14px]"
        onClick={() => {
          navigate(buildUrl("askvivo"));
        }}
      >
        <div className="flex justify-between items-center">
          <p className="font-semibold">Try it yourself!</p>
          <ArrowRightOutlined className="text-base" />
        </div>
      </button>
    </div>
  );
}
